<template>
  <div class="origin-address-class">
    <h6>Enter Origin Address</h6>
    <sb-form v-model="originAddressModel" :validator="sbValidator">
      <container>
        <row>
          <column size="12" class="origin-address-column">
            <sb-field :name="'name'">
              <sb-label>Supplier Name</sb-label>
              <sb-text-input id="name" />
            </sb-field>
          </column>
        </row>
        <row>
          <column size="8" class="origin-address-column">
            <sb-field :name="'streetAddress1'">
              <sb-label>Street Address</sb-label>
              <sb-text-input id="streetAddress1" name="streetAddress1" />
            </sb-field>
          </column>
          <column size="4" class="origin-address-column">
            <sb-field :name="'streetAddress2'">
              <sb-label>Apt/Unit</sb-label>
              <sb-text-input id="streetAddress2" name="streetAddress2" />
            </sb-field>
          </column>
        </row>
        <row>
          <column size="4" class="origin-address-column">
            <sb-field :name="'city'">
              <sb-label>City</sb-label>
              <sb-text-input id="city" name="city" />
            </sb-field>
          </column>
          <column size="4" class="origin-address-column">
            <sb-field :name="'state'">
              <sb-label>State</sb-label>
              <sb-text-input id="state" name="state" />
            </sb-field>
          </column>
          <column size="4" class="origin-address-column">
            <sb-field :name="'zipCode'">
              <sb-label>Zipcode</sb-label>
              <sb-text-input id="zip-code" name="zip-code" />
            </sb-field>
          </column>
        </row>
        <row>
          <column size="6" class="origin-address-column">
            <sb-field :name="'country'">
              <sb-label>Country</sb-label>
              <sb-dropdown
                id="country"
                name="country"
                :disabled="true"
                v-model="selectedCountry"
                :options="countries">
                <sb-selected-option slot="selection" slot-scope="{ selected }">
                  {{ selected.name }}
                </sb-selected-option>
                <sb-options>
                  <sb-option slot-scope="{ option }" :value="option" :disabled="option.disabled">
                    {{ option.name }}
                  </sb-option>
                </sb-options>
              </sb-dropdown>
            </sb-field>
          </column>
        </row>
      </container>
    </sb-form>
  </div>
</template>

<script>
import { presence } from '@/utils/formValidations'

export default {
  name: 'OriginAddress',
  components: {},
  mixins: [],
  props: {},
  data: () => ({
    originAddress: {},
    sbValidator: {
      on: 'submit',
      validateImmediate: true,
      messages: {
        presence: 'originAddress.validationMessages.presence'
      },
      validations: {
        streetAddress1: {
          validate: [presence]
        },
        city: {
          validate: [presence]
        },
        state: {
          validate: [presence]
        },
        zipcode: {
          validate: [presence]
        }
      }
    },
    selectedCountry: {},
    countries: [{ id: 1, name: 'United States of America' }]
  }),
  created () {
    this.selectedCountry = this.countries[0]
  },
  mounted () {
  },
  watch: {
  },
  computed: {
    originAddressModel: {
      get () {
        return this.$shipBobStore.getters['createWarehouseReceivingOrder/originAddress']
      },
      set (newVal) {
        this.$shipBobStore.dispatch('createWarehouseReceivingOrder/setOriginAddress', newVal)
      }
    }
  },
  methods: {
  },
  directives: {},
  filters: {},
  i18n: {
    messages: {
      'en-US': {
        originaddress: {
          validationMessages: {
            presence: 'Must be present.'
          }
        }
      }
    }
  }
}
</script>

<style lang='scss'>

.origin-address-class {
  padding: 2rem;
  background-color: whitesmoke;
}

.origin-address-column {
  padding: .5rem .3rem !important;
}

</style>
